module.exports = __webpack_public_path__ + "static/media/Person1.f36f3a52.png";